<template>
  <div
    :class="{'d-flex': isSvgSprite}"
    @click="$emit('click', $event)">
    <svg v-if="isSvgSprite">
      <use :href="svgPath" />
    </svg>
    <div
      v-else
      :class="fontIconClass">
      <slot />
    </div>
  </div>
</template>

<script>
import _find from 'lodash/find'
import svgSprite from '../assets/images/icons.svg'

const DEFAULT_ICON_SET_ID = 'mlui-core-icon'
const ICON_SETS = [
  { iconSetId: DEFAULT_ICON_SET_ID, prefix: 'mlui-core-icon icon-' },
  { iconSetId: 'fa', prefix: 'fa ' },
]

export default {
  props: {
    iconClass: {
      type: String,
      required: true,
    },
    isSvgSprite: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  computed: {
    svgPath () {
      return `${svgSprite}#icon-${this.iconClass}`
    },
    fontIconClass () {
      const iconSet = this.iconClass.split('-')[0]
      const iconSetId = iconSet === this.iconClass ? DEFAULT_ICON_SET_ID : iconSet

      const matchedIconSet = _find(ICON_SETS, (icon) => {
        return icon.iconSetId === iconSetId
      }) || _find(ICON_SETS, (icon) => icon.iconSetId === DEFAULT_ICON_SET_ID)

      return matchedIconSet ? matchedIconSet.prefix + this.iconClass : this.iconClass
    },
  },
}

</script>
